export const NotFound = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center">
      <i className="fal fa-search display-4 opacity-25 m-4"></i>
      <h1>It's 404, Not found</h1>
      <p className="opacity-50">The page you're looking for is not found. Please reach out to support!</p>
    </div>
  )
}
